import { observer } from "mobx-react";
import React, { Component } from "react";
import FilterSidebar from "../layout/FilterSidebar";
import VenueFilter from "./options/VenueFilter";

class GroundTruthFilter extends Component {
  constructor(props) {
    super(props);

    this._handleVenueChange = this._handleVenueChange.bind(this);
  }

  _handleVenueChange(venueId) {
    const { store, onChangeHandler } = this.props;
    store.update("venueId")(venueId);
    store.update("collectionDate")("");
    onChangeHandler();
  }

  render() {
    const { store } = this.props;

    return (
      <FilterSidebar>
        <VenueFilter
          simpleValue
          name="ground-truth-venue-selection"
          value={store.get("venueId")}
          onChangeHandler={this._handleVenueChange}
        />
      </FilterSidebar>
    );
  }
}

export default observer(GroundTruthFilter);



// WEBPACK FOOTER //
// ./src/components/filters/GroundTruthFilter.js